import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { cloudDownload } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import Logger from '../../../services/logger.service'

const EKGImportButton: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation()

  const onEKGImportClick = () => {
    Logger.info('ECGImport: The user has started the ECG flow')
    history.push(AppRouterConstants.EKG_IMPORT_ROUTE)
  }

  return (
    <IonButton
      data-testid='EKGImport'
      className='ekg-import-button'
      expand='block'
      fill='clear'
      onClick={onEKGImportClick}
      color='primary-alt'>
      <IonIcon icon={cloudDownload} size='large' />
      {t('ekg.ekgImport')}
    </IonButton>
  )
}

export default EKGImportButton
